import { Branding } from '../Branding';
import midletonLogo from '../../assets/logoMS.svg';

export const midletonBranding: Branding = {
  name: 'Midleton School',
  logo: midletonLogo,
  orgEmail: 'info@midletonschool.com',
  orgPhone: '+34 91 228 58 94',
  privacyPolicyUrl: 'https://www.midletonschool.com/politica-de-privacidad/',
  defaultLocale: 'es',
  withPayment: false,
};
